import queryString from 'query-string';
import http from '../httpConfig';
import { StockistProductAddEditApi, ListStockistProduct } from '../interfaces/stockist.interface';
import { API_ENDPOINTS } from '../utils/apiConstant';
import { buildPagingResponse } from '../utils/methods';

const list = (payload: ListStockistProduct) => {
  const { searchText, status, stockist_id, ...others } = payload;
  const paging = buildPagingResponse(others);
  const queryParams: any = {
    ...paging,
    search: searchText,
    status,
    stockist_id,
  };

  const url = `${API_ENDPOINTS.listStockistProducts}?${queryString.stringify(queryParams)}`;
  return http.get(url);
};

const add = (payload: StockistProductAddEditApi) => {
  return http.post(API_ENDPOINTS.addStockistProduct, payload);
};

const edit = (id: string, payload: StockistProductAddEditApi) => {
  return http.put(`${API_ENDPOINTS.editStockistProduct}/${id}`, payload);
};

const deleteProduct = (id: string) => {
  return http.delete(`${API_ENDPOINTS.deleteStockistProduct}/${id}`);
};

const get = (id: string) => {
  return http.get(`${API_ENDPOINTS.getStockistProduct}/${id}`);
};

const StockistProductService = {
  list,
  add,
  edit,
  delete: deleteProduct,
  get,
};

export default StockistProductService;
